import React, { memo } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

const Span = styled.span`
  color: #999999;
  font-size: 20px;
  margin: 2rem auto 0;
`;

const TotalCards = memo(({ total }) => {
  return <Span>Total Cards: {total}</Span>;
});

TotalCards.propTypes = { total: PropTypes.number.isRequired };

export { TotalCards };
